import { AbilityBuilder, Ability } from '@casl/ability'
export { setAbilities }
export const ability = new Ability()

function hasRole (user, role) {
  if (!user) {
    return false
  }
  if (!user.roles) {
    return false
  }
  return user.roles.indexOf(role) !== -1
}

function defineAbilitiesFor (user) {
  const { rules, can: allow, cannot: forbid } = AbilityBuilder.extract()

  console.log('defineAbilitiesFor start:')
  console.log(user)
  allow('view', 'Main')

  if (user && user.userDomain) {
    console.log('user && user.domain start')
    switch (user.userDomain) {
      case 'WORKER':
        console.log('WORKER start')
    }
  } else {
    // Unathorized user
    console.log('Unathorized user start')
  }
  return rules
}

function setAbilities (user) {
  console.log('setAbilities start')
  var rules = defineAbilitiesFor(user)
  ability.update(rules)
}

export default ability
